import gql from 'graphql-tag';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

// Kept in its own module (rather than alongside `PersistedDataFrameTableWrapper`) so it can be imported by
// `prefetchPersistedDataFramePages.ts` without introducing a circular import between the two.
//
// eslint doesn't recognize that $limit/$offset/$sortInput are used within the PersistedDataFrameGraphQL
// fragment
export const GET_PERSISTED_DATA_FRAME_QUERY = gql`
  query GetPersistedDataFrame(
    $dataFrameId: StrictString!
    $limit: StrictInt!
    $offset: StrictInt = 0
    $sortInput: DataFrameSortInput
  ) @skipAudit @engComponent(name: DATA_FRAMES) {
    dataFrame(id: $dataFrameId) {
      ...InaccessibleInfoGraphQL
      ...PersistedDataFrameGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
  ${getFragmentWrapper('PersistedDataFrame').fragment}
`;
